<template>
    <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index" @click="updateInfo(item)">
            <div class="info">
                <div>
                    <p>注册姓名</p>
                    <p>{{ item.username }}</p>
                </div>
                <div>
                    <p>注册手机号</p>
                    <p>{{ item.reg_mobile }}</p>
                </div>
                <div>
                    <p style="flex-shrink: 0;">注册工作单位</p>
                    <p style="margin-left: 10px;">{{ item.company }}</p>
                </div>
                <div>
                    <p>支付状态</p>
                    <p>{{ item.pay_status ? '已支付' : '未支付' }}</p>
                </div>
            </div>

            <div class="btn">修改开票信息</div>
        </div>
        <div class="bottom" @click="goBack">返回首页</div>
    </div>

</template>
<script>
import { PayInfoList } from '../../../config/interface.js'

export default {
    data() {
        return {
            list: [],
            meeting_id: this.$route.query.meeting_id
        }
    },
    mounted() {
        this.getPayInfoList()

    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        updateInfo(val) {
            this.$router.push({
                path: '/vascularNews/chargeInfo/collectInfo',
                query: {
                    reg_id: val.reg_id,
                    meeting_id: this.meeting_id
                }
            })
        },
        getPayInfoList() {
            const url = PayInfoList;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data
                    }
                })
        }
    }
}

</script>
<style lang="scss" scoped>
.list {
    width: 100%;
    min-height: 100vh;
    position: relative;
    padding: 15px;
    background: #fff;
    padding-bottom: 100px;

    .item {
        .info {
            width: 100%;
            background: #F7F7F8;
            border-radius: 5px;
            margin-bottom: 10px;
            padding: 20px 15px;
            display: flex;
            flex-direction: column;
            gap: 15px;

            &>div {
                display: flex;
                justify-content: space-between;
                // align-items: center;
                font-size: 14px;
            }
        }

        .btn {
            width: 100%;
            background: #901D22;
            border-radius: 5px;
            margin-bottom: 30px;
            color: #fff;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
        }

    }

    .bottom {
        position: fixed;
        bottom: 30px;
        width: 165px;
        line-height: 45px;
        background: #901D22;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-size: 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/ChargeInfo/historyList.vue